var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('manager-wholesale-discounts',{attrs:{"submitText":"Crear esquema","crudOption":"create"},on:{"clear-form":_vm.clearForm,"submit-form":_vm.submitForm,"cancel-editing":_vm.restartEditing}},[_c('product-data')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }